<template>
  <div class="wrap" @mouseleave="hideCity">
    <div class="isSelect">
      <div class="selectTitle">
        {{TLang('已选','my')}}
      </div>
      <div class="selectItems">
        <div class="cityItem">{{CheckCN()?currentCity.name:currentCity.pinyin }}</div>
        <ul class="tagList">
          <li class="hover" v-for="(item, index) in tagList" :key="index">
            {{
              item.minPrice === "500" && !item.maxPrice ? "500以上" : item.value
            }}
            <i
              class="iconfont health__popup_close"
              @click="close(item.type)"
            ></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="cityList">
      <div class="cityTitle">
        {{TLang('城市','my')}}
      </div>
      <div class="cityWrap">
        <ul>
          <li v-for="item in hotCityList" :key="item.cityId">
            <span
              :class="item.cityId == currentCityId ? 'select' : ''"
              @click="selectCity(item)"
              >{{ CheckCN()?item.name:item.pinyin}}</span
            >
          </li>
        </ul>
        <div class="more" @mouseover="showCity">
          {{TLang('更多','my')}}<i
            class="sanjiao"
            :class="cityShow ? 'top' : ''"
            @mouseover="showCity"
          ></i>
        </div>
      </div>
    </div>
    <div class="cityhover" v-show="cityShow" @mouseover="showCity">
      <!-- <div style="height:1px;background-color:#E0E6ED;width:870px;"></div> -->
      <div class="words">
        <ul>
          <li
            @click="select(item, index)"
            v-for="(item, index) in wordList"
            :key="index"
            :class="selectWordIndex == index ? 'select' : ''"
          >
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
      <div class="list">
        <ul>
          <li
            class="wordCityList"
            v-for="(item, index) in cities"
            :key="index + 'qwe'"
          >
            <div class="firstWord">{{ item.first }}</div>
            <ul class="Awrap">
              <li v-for="(value, key) in item.arr" :key="key">
                <span
                  :class="
                    value.cityId == currentCityId && !isHotCity(value.cityId)
                      ? 'select'
                      : ''
                  "
                  @click="selectCity(value)"
                  >{{ CheckCN()?value.name: value.pinyin }}</span
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div class="kinds">
        <!-- 一级分类 -->
        <div class="kindsTitle">
          {{TLang('分类','my')}}
        </div>
        <div class="kindsContent">
          <ul>
            <li v-for="(item, index) in categoryList" :key="index">
              <span
                :class="{
                  selectDown: item.id == parentId && kindsShow,
                  selectUp: item.id == parentId && !kindsShow
                }"
                @click="showKinds(item)"
                >{{ item.name }}<i></i
              ></span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 二级分类 -->
      <div class="kindsHover" v-show="kindsShow">
        <div class="container">
          <ul>
            <!-- <li><span class="select">全部</span></li> -->
            <li v-for="(item, index) in kindList" :key="index">
              <span
                :class="item.id == categoryId ? 'select' : ''"
                @click="selectKinds(item)"
                >{{ item.name }}</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="time">
      <div class="timeTitle">{{TLang('时间','my')}}</div>
      <div class="titleOptions">
        <ul>
          <li
            v-for="(item, index) in timeList"
            :key="index"
            @click="selectTime(item)"
          >
            <span
              :class="{
                select: timeLable == item.value && !isZidingyi
              }"
              >{{ item.value }}</span
            >
          </li>
          <li class="zidingyi" @mouseleave="upDatePicker">
            <span @mouseover="downDatePicker" :class="{ select: isZidingyi }"
              >{{TLang('自定义','my')}}</span
            >
            <DatePanel
              v-model="date"
              :show-time="true"
              v-if="dataPickerShow"
              @change="changeDate"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="time">
      <div class="timeTitle">{{TLang('票价','my')}}</div>
      <div class="titleOptions">
        <ul>
          <li v-for="(item, key) in priceList" :key="key">
            <span
              :class="{ select: selectedPrice == item.value }"
              @click="selectPrice(item)"
              >{{ item.value }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import DatePanel from "@/components/datePicker/datePanel.vue";
import { dateFormat } from "@/utils";
export default {
  name: "selectModule",
  data() {
    return {
      timeList: [],
      tagList: this.tags,
      currentCity: {},
      parentName: "",
      kindsName: this.listName,
      parentId: this.$route.query.parentId, // 一级分类id
      categoryId: this.$route.query.categoryId, // 二级分类id
      currentCityId: this.$route.query.city, //当前城市ID
      hotCityList: [], // 热门城市
      cities: [], // 所有城市
      wordList: ["ABCDEFG", "HIJK", "MNPQRST", "WXYZ"],
      selectWordIndex: 0, //默认选中ABCDEFG
      cityShow: false, //默认不展示所有城市
      kindsShow: !!this.$route.query.categoryId, // 默认所有种类都关闭
      categoryList: this.category, //一级分类
      kindList: [], //二级分类
      priceList: [
        { minPrice: "0", maxPrice: "100", type: "price", value: "0-100" },
        { minPrice: "100", maxPrice: "200", type: "price", value: "100-200" },
        { minPrice: "200", maxPrice: "500", type: "price", value: "200-500" },
        { minPrice: "500", maxPrice: "1000", type: "price", value: "500-1000" }
      ],
      date: new Date(),
      dataPickerShow: false,
      timeLable: "",
      isZidingyi: false, // 当前是否选择自定义
      minPrice: this.minPriceOut,
      maxPrice: this.maxPriceOut,
      selectedPrice: ""
    };
  },
  created() {
    this.timeList[0] = {
      value: TLang('本周内','my',false,false,null),
      startTime: dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
      endTime: this.getWeekDay().endTime,
      type: "time"
    };

    this.timeList[1] = {
      value: TLang('本周末','my',false,false,null),
      ...this.getWeekDay(),
      type: "time"
    };
    this.timeList[2] = {
      value: TLang('本月内','my',false,false,null),
      startTime: dateFormat(
        new Date().getTime() + 24 * 60 * 60 * 1000,
        "yyyy-MM-dd hh:mm:ss"
      ),
      endTime: `${this.getLastDay()} 23:59:59`,
      type: "time"
    };
  },
  watch: {
    // 初始化tagList
    categoryList() {
      this.categoryList.forEach(value => {
        if (value.id == this.parentId) {
          this.kindList = [
            {
              name: TLang('全部','home',false,false,null),
              id: value.id,
              parentid: value.id
            }
          ].concat(value.children);
          this.parentId = value.id;
          this.categoryId = this.$route.query.categoryId || value.id;
          this.kindsShow = true;

          // this.showKinds(value);
          // this.categoryId = this.$route.query.categoryId || value.id;
          this.parentName = value.name;
          value.children.forEach(item => {
            if (item.id == this.categoryId) {
              this.kindsName = item.name;
              this.$emit("getListName", this.kindsName);
            }
          });
        }
      });
      if (this.parentName && this.kindsName) {
        this.tagList.push({
          value: `${this.parentName}-${this.kindsName}`,
          id: this.categoryId,
          type: "categoryId"
        });
      }
    },
    tags(val) {
      this.tagList = val;
      if (val.length == 0) {
        this.parentId = "";
        this.categoryId = "";
        this.timeLable = "";
        this.isZidingyi = false;
        this.selectedPrice = "";
        this.minPrice = "";
        this.maxPrice = "";
      }
    },
    minPriceOut() {
      //this.outPriceChange();
    },
    maxPriceOut() {
      //this.outPriceChange();
    }
  },
  props: {
    tags: Array,
    category: Array,
    minPriceOut: [Number, String],
    maxPriceOut: [Number, String],
    listName: String
  },
  components: {
    DatePanel
  },
  methods: {
    ...mapMutations(["setCityList"]),
    // 删除当前选择价格项目
    deletePeiceTag() {
      // let repeat = false;
      let index1 = -1;
      this.tagList.forEach((value, index) => {
        if (value.type == "price") {
          // repeat = true;
          index1 = index;
        }
      });
      if (index1 != -1) {
        this.tagList.splice(index1, 1);
        this.selectedPrice = "";
      }
    },
    getLastDay() {
      var seperator1 = "-";
      var date = new Date();
      var new_month = date.getMonth() + 1;
      var new_year = date.getFullYear();
      var new_date = new Date(new_year, new_month, 1);
      var currentdate =
        new_year +
        seperator1 +
        new_month +
        seperator1 +
        new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate();
      return currentdate;
    },
    outPriceChange() {
      let repeat = false;
      let index1 = -1;
      this.tagList.forEach((value, index) => {
        if (value.type == "price") {
          repeat = true;
          index1 = index;
        }
      });
      let obj = {
        type: "price",
        minPrice: this.minPriceOut,
        maxPrice: this.maxPriceOut,
        value: (() => {
          if (this.minPriceOut && !this.maxPriceOut) {
            return `${this.minPriceOut}以上`;
          } else if (!this.minPriceOut && this.maxPriceOut) {
            return `${this.maxPriceOut}以下`;
          }
          return `${this.minPriceOut}-${this.maxPriceOut}`;
        })()
      };
      this.selectedPrice = obj.value;
      if (this.minPriceOut !== "" || this.maxPriceOut !== "") {
        if (index1 != -1) {
          this.$set(this.tagList, index1, obj);
        }
        // 没有标签
        if (!repeat) {
          this.tagList.push(obj);
        }
      } else {
        if (index1 != -1) {
          this.tagList.splice(index1, 1);
        }
      }

      // this.$emit("query", this.tagList);
    },
    selectPrice(item) {
      this.selectedPrice = item.value;
      if (item.minPrice) {
        this.minPrice = item.minPrice;
      }
      if (item.maxPrice) {
        this.maxPrice = item.maxPrice;
      }
      let repeat = false;
      let index1 = -1;
      this.tagList.forEach((value, index) => {
        if (value.type == "price") {
          repeat = true;
          index1 = index;
        }
      });
      if (index1 != -1) {
        this.$set(this.tagList, index1, item);
      }
      if (!repeat) {
        this.tagList.push(item);
      }
      this.$emit("query", this.tagList);
    },
    // 选择时间
    selectTime(item) {
      this.timeLable = item.value;
      this.isZidingyi = false;
      let repeat = false;
      let index1 = -1;
      this.tagList.forEach((value, index) => {
        if (value.type == "time") {
          repeat = true;
          index1 = index;
        }
      });
      if (index1 != -1) {
        this.$set(this.tagList, index1, item);
      }
      if (!repeat) {
        this.tagList.push(item);
      }
      this.$emit("query", this.tagList);
    },
    getWeekDay() {
      let _date = new Date();
      let _nowTime = _date.getTime();
      let _week = _date.getDay();
      let _dayLongTime = 24 * 60 * 60 * 1000;
      let _furtureSundayTimes = _nowTime + (7 - _week) * _dayLongTime;
      let _furtureSaturdayTimes = _nowTime + (6 - _week) * _dayLongTime;
      _furtureSundayTimes = new Date(_furtureSundayTimes);
      _furtureSaturdayTimes = new Date(_furtureSaturdayTimes); // staurday
      let _satYear = _furtureSaturdayTimes.getFullYear();
      let _satMonth = _furtureSaturdayTimes.getMonth() + 1;
      let _satDay = _furtureSaturdayTimes.getDate(); //sunday
      let _sunYear = _furtureSundayTimes.getFullYear();
      let _sunMonth = _furtureSundayTimes.getMonth() + 1;
      let _sunDay = _furtureSundayTimes.getDate();
      _satMonth = _satMonth >= 10 ? _satMonth : "0" + _satMonth;
      _satDay = _satDay >= 10 ? _satDay : "0" + _satDay;
      _sunMonth = _sunMonth >= 10 ? _sunMonth : "0" + _sunMonth;
      _sunDay = _sunDay >= 10 ? _sunDay : "0" + _sunDay;
      let _mealSunDay = _satYear + "-" + _satMonth + "-" + _satDay;
      let _mealSaturDay = _sunYear + "-" + _sunMonth + "-" + _sunDay;
      let _weekendDay = {
        startTime: _mealSunDay + " 00:00:00",
        endTime: _mealSaturDay + " 23:59:59"
      };
      if (new Date().getTime() > new Date(_weekendDay.startTime).getTime()) {
        _weekendDay.startTime = dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss");
      }
      return _weekendDay;
    },
    close(type) {
      let index1 = -1;
      this.tagList.forEach((value, index) => {
        if (value.type == type) {
          index1 = index;
          if (type == "categoryId") {
            this.parentId = "";
            this.categoryId = "";
          } else if (type == "time") {
            this.timeLable = "";
            this.isZidingyi = false;
          } else if (type == "price") {
            this.selectedPrice = "";
            this.minPrice = "";
            this.maxPrice = "";
          }
        }
      });
      this.tagList.splice(index1, 1);
      this.$emit("query", this.tagList);
    },
    changeDate(date) {
      this.selectTime({
        type: "time",
        value: date,
        startTime: `${date} 00:00:00`,
        endTime: `${date} 23:59:59`
      });
      this.isZidingyi = true;
      this.dataPickerShow = false;
    },
    downDatePicker() {
      this.dataPickerShow = true;
    },
    upDatePicker() {
      this.dataPickerShow = false;
    },

    showKinds(item) {
      if (item.id === this.parentId) {
        this.kindsShow = !this.kindsShow;
        return;
      }
      this.kindList = [
        {
          name: TLang('全部','home',false,false,null),
          id: item.id,
          parentid: item.id
        }
      ].concat(item.children);
      this.parentId = item.id;
      this.categoryId = item.id;
      this.kindsShow = true;
      this.selectKinds({
        name: TLang('全部','home',false,false,null),
        id: item.id,
        parentid: item.id
      });
    },
    // 点击二级分类事件
    selectKinds(item) {
      this.categoryId = item.id;
      this.parentId = item.parentid;
      let that = this;
      this.parentName = (function() {
        let parentName;
        that.categoryList.forEach(value => {
          if (value.id == that.parentId) {
            parentName = value.name;
          }
        });
        return parentName;
      })();
      this.kindsName = item.name;
      let repeat = false;
      this.tagList.forEach(value => {
        if (value.type == "categoryId") {
          repeat = true;
          value.value = `${this.parentName}-${this.kindsName}`;
          value.id = this.categoryId;
        }
      });
      if (!repeat) {
        this.tagList.push({
          value: `${this.parentName}-${this.kindsName}`,
          id: this.categoryId,
          type: "categoryId"
        });
      }
      this.$emit("query", this.tagList);
    },
    showCity() {
      this.cityShow = true;
    },
    hideCity() {
      this.cityShow = false;
    },
    isHotCity(id) {
      let repeat = false;
      this.hotCityList.forEach(value => {
        if (value.cityId == id) {
          repeat = true;
        }
      });
      return repeat;
    },
    dealCities(selectWords) {
      let arr = [],
        outArr = []; //输出的数组
      this.cityList.cityList.forEach(value => {
        value.first = value.first.toLocaleUpperCase();
        let repeat = false; //判断是否当前已经有当前开头的字母
        let index = 0;
        arr.forEach((item, index1) => {
          if (value.first == item.first) {
            repeat = true;
            index = index1;
          }
        });
        if (!repeat) {
          arr.push({
            first: value.first,
            arr: [{ name: value.name, pinyin: value.pinyin, cityId: value.cityId }]
          });
        } else {
          arr[index].arr.push({
            name: value.name,
            cityId: value.cityId,
            pinyin: value.pinyin,
          });
        }
      });
      arr.forEach(value => {
        if (selectWords.indexOf(value.first) != -1) {
          outArr.push(value);
        }
      });
      return outArr;
    },
    select(word, index) {
      this.cities = this.dealCities(word);
      this.selectWordIndex = index;
    },
    selectCity(item) {
      this.currentCity = item;
      this.currentCityId = item.cityId;
      this.$router.replace({
        query: { ...this.$route.query, city: item.cityId }
      });
      this.$emit("query", this.tagList);
    }
  },
  mounted() {
    this.apis.headerApi.getCityData().then(res => {
      this.cityList = res;
      this.currentCity = {
        name: this.cityList.cityName,
        pinyin: this.cityList.cityPinyin,
        cityId: this.cityList.city
      };
      this.hotCityList = this.cityList.hotCities;
      this.cities = this.dealCities("ABCDEFG");
    });
  }
};
</script>
<style lang="less" scoped>
.wrap {
  font-size: 14px;
  width: 914px;
  border: 1px solid rgba(224, 230, 237, 1);
  box-shadow: 0px 0px 0px 0px rgba(224, 230, 237, 1);
  position: relative;
  .isSelect {
    .clearfix;
    height: 52px;
    text-align: center;
    .selectTitle {
      float: left;
      width: 72px;
      line-height: 52px;
      color: #999999;
      cursor: default;
    }
    .selectItems {
      float: left;
      .clearfix;
      .cityItem {
        float: left;
        padding: 2px 8px 3px;
        border: 1px solid #e0e6ed;
        margin-top: 12px;
        color: #666666;
        cursor: default;
        border-radius: 2px;
      }
      .tagList {
        float: left;
        .clearfix;
        li {
          height: 28px;
          line-height: 24px;
          border: 1px solid #e0e6ed;
          margin-top: 12px;
          padding: 0 6px 0 8px;
          margin-left: 12px;
          color: #666666;
          cursor: default;
          border-radius: 2px;
          float: left;
          i {
            position: relative;
            top: 2px;
            right: 0px;
            cursor: pointer;
            color: #cbcdce;
            font-weight: bold;
          }
        }
        li:hover {
          border: 1px solid #3FA6FF;
          border: 1px solid var(--df-primary-color, #3FA6FF);
          i {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
          }
        }
      }
    }
  }
  .cityList {
    .clearfix;
    line-height: 44px;
    text-align: center;
    .cityTitle {
      width: 72px;
      color: #999999;
      cursor: default;
      float: left;
    }
    .cityWrap {
      width: 818px;
      line-height: 44px;
      float: left;
      position: relative;
      ul {
        .clearfix;
        padding-right:  70px;
      }
      ul li {
        float: left;
        margin-left: 4px;
        color: #222222;
        span {
          padding: 5px 12px;
          border-radius: 2px;
          cursor: pointer;
        }
        .select {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
        }
      }
      ul li:nth-child(1) {
        margin-left: 0;
      }
      ul li:hover {
        span {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
        }
      }
      .more {
        position: absolute;
        right: 10px;
        height: 100%;
        top: 0;
        padding-left: 20px;
        cursor: pointer;
        color: #222222;
        .sanjiao {
          position: absolute;
          width: 0;
          height: 0;
          right: -10px;
          top: 21px;
          border: 5px solid;
          border-color: #cbcdce transparent transparent transparent;
          // transition: all 0.3s ease-in-out;
        }
        .top {
          border-color: transparent transparent #cbcdce transparent;
          top: 16px;
        }
      }
      .more:hover {
        .sanjiao {
          border-color: transparent transparent #3FA6FF transparent;
          border-color: transparent transparent var(--df-primary-color, #3FA6FF) transparent;
          top: 16px;
        }
      }
    }
  }
  .cityhover::-webkit-scrollbar {
    display: block;
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #e9ebed;
  }
  .cityhover {
    background-color: #fff;
    position: absolute;
    z-index: 10;
    // width: 890px;
    // height: 184px;
    // height: 132px;
    overflow-y: scroll;
    top: 96px;
    left: 20px;
    font-size: 12px;
    .words {
      height: 44px;
      line-height: 40px;
      border-top: 1px dashed #e0e6ed;
      width: 866px;
      ul {
        height: 100%;
        .clearfix;
        li {
          cursor: pointer;
          float: left;
          margin-left: 12px;
          height: 100%;
          span {
            padding: 4px 2px;
            margin-top: 10px;
          }
        }
        li:nth-child(0) {
          margin-left: 0;
        }
        li.select {
          span {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          }
        }
        li:hover span {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
        }
      }
    }
    .list {
      line-height: 32px;
      width: 100%;
      .clearfix;
      .firstWord {
        height: 100%;
        color: #3d96e2;
        font-weight: 600;
        float: left;
        width: 21px;
        text-align: left;
      }
      .Awrap {
        float: left;
        width: 850px;
        .clearfix;
        li {
          float: left;
          margin-right: 8px;
          cursor: pointer;
          span {
            padding: 5px 12px;
          }
          span:hover {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          }
          span.select {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          }
        }
      }
    }
  }
  .kinds {
    line-height: 44px;
    text-align: center;
    .clearfix;
    .kindsTitle {
      width: 72px;
      color: #999999;
      height: 100%;
      float: left;
    }
    .kindsContent {
      width: 818px;
      float: left;
      .clearfix;
      ul li {
        float: left;
        box-sizing: border-box;
        margin-left: 4px;
        position: relative;
        span {
          padding: 5px 12px;
          cursor: pointer;
          &:hover {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            i {
              border-color: rgba(61, 150, 226, 1) transparent transparent
                transparent;
              border-color: var(--df-primary-color, #3FA6FF) transparent transparent
                transparent;
            }
          }
          i {
            display: inline-block;
            width: 0;
            height: 0;
            position: relative;
            top: 4px;
            right: -2px;
            border: 5px solid;
            border-color: #cbcdce transparent transparent transparent;
            // transition: all 0.3s ease-in-out;
          }
        }
        span.selectUp {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          i {
            border-color: #3FA6FF transparent transparent
              transparent;
            border-color: var(--df-primary-color, #3FA6FF) transparent transparent
              transparent;
          }
        }
        span.selectDown {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          i {
            border-color: transparent transparent #3FA6FF
              transparent;
            border-color: transparent transparent var(--df-primary-color, #3FA6FF)
              transparent;
            top: -2px;
          }
        }
        span.selectHover {
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
          background: rgba(63, 166, 255, 0.1);
          background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          i {
            border-color: #3FA6FF transparent transparent
              transparent;
            border-color: var(--df-primary-color, #3FA6FF) transparent transparent
              transparent;
          }
        }
      }
      ul li:nth-child(1) {
        margin-left: 0;
      }
    }
  }
  .kindsHover {
    background-color: #fff;
    // position: absolute;
    width: 912px;
    line-height: 44px;
    // top: 139px;
    // left: 0;
    font-size: 12px;
    z-index: 11;
    box-shadow: 0px 3px 6px 0px rgba(53, 59, 64, 0.06);
    .container {
      margin-left: 72px;
      ul {
        .clearfix;
        li {
          float: left;
          span {
            padding: 5px 12px;
            margin-right: 24px;
            border-radius: 2px;
            cursor: pointer;
          }
          span.select,
          span:hover {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          }
        }
      }
    }
  }
  .time {
    line-height: 44px;
    .clearfix;
    .timeTitle {
      width: 72px;
      text-align: center;
      float: left;
      color: #999999;
      cursor: pointer;
    }
    .titleOptions {
      float: left;
      ul {
        .clearfix;
        li {
          float: left;
          margin-right: 4px;
          span {
            padding: 5px 12px;
            color: #222222;
            cursor: pointer;
          }
          span.select,
          span:hover {
            color: #3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
            background: rgba(63, 166, 255, 0.1);
            background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
          }
        }
      }
    }
  }
}
/deep/.el-date-picker__time-header {
  display: none;
}
/deep/.el-picker-panel__icon-btn.el-date-picker__next-btn.el-icon-d-arrow-right {
  display: none;
}
/deep/.el-picker-panel__icon-btn.el-date-picker__prev-btn.el-icon-d-arrow-left {
  display: none;
}
.zidingyi {
  position: relative;
  height: 44px;
  span {
    padding: 5px 12px;
    color: #222222;
    cursor: pointer;
  }
  .select {
    color: #3FA6FF;
    color: var(--df-primary-color, #3FA6FF);
    background: rgba(63, 166, 255, 0.1);
    background: var(--df-primary-color-opacity, rgba(63, 166, 255, 0.1));
  }
}
.date-panel {
  position: absolute;
  top: 30px;
  left: 12px;
}
/deep/.el-picker-panel__body {
  box-shadow: 0px 1px 4px 0px rgba(53, 59, 64, 0.15);
  position: absolute;
  top: 0px;
  z-index: 100;
  background-color: white;
}
</style>
